<template>
  <div class="container-fluid py-3">
    <div class="d-flex align-items-center mb-3">
      <span class="mr-2" style="color:#F7931A; font-size:1.1rem; font-weight:700">Bitcoin</span>
      <h5 class="mb-0 mr-3">Transaction History</h5>
      <router-link to="/bitcoin" class="btn btn-sm btn-outline-secondary">← Wallet</router-link>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="input-group input-group-sm">
          <input class="form-control" v-model="address" placeholder="bc1… or 1… or 3…" @keyup.enter="load" />
          <div class="input-group-append">
            <button class="btn btn-sm" style="background:#F7931A;color:#fff" @click="load" :disabled="loading">
              {{ loading ? 'Loading…' : 'Load' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <p class="text-muted small">Data via Blockstream API. Shows 25 most recent transactions.</p>
    <TxTable :txs="txs" :loading="loading" accent-color="#F7931A" />
  </div>
</template>

<script>
import TxTable from '../components/TxTable.vue';
import { fetchBtcTxs } from '../services/txService';

export default {
  name: 'BtcTransactions',
  components: { TxTable },
  data() { return { address: '', txs: [], loading: false }; },
  methods: {
    async load() {
      if (!this.address.trim()) return;
      this.loading = true;
      try { this.txs = await fetchBtcTxs(this.address.trim()); }
      catch (e) { alert('Error: ' + e.message); }
      finally { this.loading = false; }
    },
  },
  mounted() {
    const w = this.$store && this.$store.state.wallets.bitcoin;
    if (w && w.address) { this.address = w.address; this.load(); }
  },
};
</script>
